import LogoAccenture from "./LogoAccenture";
import LogoAmmagamma from "./LogoAmmagamma";

const PoweredBy = () => {
    return (
<div className="flex items-center justify-center gap-6 mt-14">
    <p className="pt-6">Powered by</p>
    <a
        href="https://www.accenture.com/"
        target="_blank"
        rel="noopener noreferrer"
    >
        <LogoAccenture color="black" />
    </a>
    <a
        href="https://www.ammagamma.com"
        target="_blank"
        rel="noopener noreferrer"
    >
        <LogoAmmagamma color="black" />
    </a>
</div>

    );
};

export default PoweredBy;
